<sb-searchable-list-section
	[editableInStoryblok]="_editable"
	[hideFilter]="hideFilter()"
	[hidePriceFilter]="true"
	[persuadeCards]="hotels()"
	[title]="title()"
	[useStoryblokCards]="false"
/>
